import { render, staticRenderFns } from "./MemberSet.vue?vue&type=template&id=a96b39b4&scoped=true"
import script from "./MemberSet.vue?vue&type=script&lang=js"
export * from "./MemberSet.vue?vue&type=script&lang=js"
import style0 from "./MemberSet.vue?vue&type=style&index=0&id=a96b39b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96b39b4",
  null
  
)

export default component.exports